import type { SkillType } from '@vuganawe/types';

/**
 * Brand-derived accent per skill area. Used for course-cover art, list
 * stripes, and chips so each area is recognizable at a glance across the
 * admin studio, the catalog, and the player.
 */
export const SKILL_COLORS: Record<SkillType, { base: string; deep: string }> = {
  SPEAKING: { base: '#f6921e', deep: '#c26f0a' },
  LISTENING: { base: '#3d8fc4', deep: '#2a6b96' },
  GRAMMAR: { base: '#054676', deep: '#03304f' },
  VOCABULARY: { base: '#b65c32', deep: '#8c4322' },
  READING: { base: '#2e7d4f', deep: '#1f5c38' },
  WRITING: { base: '#7d5b9e', deep: '#5d4079' },
  PRONUNCIATION: { base: '#b07b10', deep: '#89600a' },
};

/** Short glyph shown on generated course covers (no image assets needed). */
export const SKILL_GLYPHS: Record<SkillType, string> = {
  SPEAKING: 'Aa',
  LISTENING: '((',
  GRAMMAR: 'S+V',
  VOCABULARY: 'abc',
  READING: '¶',
  WRITING: '✎',
  PRONUNCIATION: 'əː',
};

/** "1 h 05 min" / "45 min" formatting for course durations. */
export function formatMinutes(total: number): string {
  if (total <= 0) return '—';
  const hours = Math.floor(total / 60);
  const minutes = total % 60;
  if (hours === 0) return `${minutes} min`;
  if (minutes === 0) return `${hours} h`;
  return `${hours} h ${String(minutes).padStart(2, '0')} min`;
}

/** Derive a lowercase-hyphenated slug from a human title. */
export function slugify(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 120);
}
